// extracted by mini-css-extract-plugin
module.exports = {"close-button":"_1hgtL","wrapper":"_3mtYa"};